import type {
  GroupResultDTO,
  UserResultDTO,
} from '@nora-monorepo/nora-api-client';

import type { UsersAndGroups } from '#ui-shared/components/member-picker/member-picker-types';

export function selectVisibleUsers(
  members: UsersAndGroups,
  users: UserResultDTO[],
  roleId: string,
): UsersAndGroups {
  const selectedUserIds = new Set(members.users.map(member => member.user.id));
  const usersToAdd = users
    .filter(user => !selectedUserIds.has(user.id))
    .map(user => ({ user, role: roleId }));

  if (usersToAdd.length === 0) {
    return members;
  }

  return {
    ...members,
    users: [...members.users, ...usersToAdd],
  };
}

export function deselectVisibleUsers(
  members: UsersAndGroups,
  users: UserResultDTO[],
): UsersAndGroups {
  const visibleUserIds = new Set(users.map(user => user.id));

  return {
    ...members,
    users: members.users.filter(member => !visibleUserIds.has(member.user.id) || member.nonRemovable),
  };
}

export function selectVisibleGroups(
  members: UsersAndGroups,
  groups: GroupResultDTO[],
  roleId: string,
): UsersAndGroups {
  const selectedGroupIds = new Set(members.groups.map(member => member.group.id));
  const groupsToAdd = groups
    .filter(group => !selectedGroupIds.has(group.id))
    .map(group => ({ group, role: roleId }));

  if (groupsToAdd.length === 0) {
    return members;
  }

  return {
    ...members,
    groups: [...members.groups, ...groupsToAdd],
  };
}

export function deselectVisibleGroups(
  members: UsersAndGroups,
  groups: GroupResultDTO[],
): UsersAndGroups {
  const visibleGroupIds = new Set(groups.map(group => group.id));

  return {
    ...members,
    groups: members.groups.filter(member => !visibleGroupIds.has(member.group.id)),
  };
}
